import { ParticipationResponseData } from "./response-data";

export class PrintRequest {
    resptype:string;
    page:string;
    isResultOnly:boolean;
    multi:string;
    langname:string;
    recno:string;
    format:string;
    pageno:string;
    pdftopage:string;
    pgno:string;
    type:string;
    email:string;
    isPBSDonwload: boolean;
    isNew:string;
    strDir:string;
    trackId:string;       
    pdfLastPage:string;
    lang:string;
    base64Img:string;
    Sid:string;
    corpNo:string;
    strAngularHost:string;
    isFromAllProjectDashboard: boolean;
    participationResponseData:ParticipationResponseData;
}

export class ScannerRequest
{
     CorpNo:number;
     SurveyNo :number;
    Lang: number;
    isFromAllProjectDashboard: boolean;
}


